import { useRouter } from 'next/router';
import React, { FC } from 'react';
import { useFrame } from '~/shared/utils';
import { useTranslation } from '~/shared/utils/translation';
import useProducts from '../../../commerce-api/hooks/useProducts';
import styles from './FreeShippingNotice.module.scss';
import Typography from '~/shared/components/Typography/Typography';

export const FreeShippingNotice: FC = () => {
    const router = useRouter();
    const { translate } = useTranslation();

    const {
        data: { settings },
    } = useFrame();

    const { handlers } = useProducts();

    const storage = globalThis?.sessionStorage;
    const prevPath = storage?.getItem('prevPath');

    const goBack = () => {
        const { hostname } = window.location;
        if (
            prevPath !== settings?.pageReferences?.checkoutPage?.url &&
            prevPath !== router.asPath &&
            prevPath?.includes(hostname)
        ) {
            router.back();
        } else {
            router.push('/');
        }
    };

    const hasFreeShipping = handlers.getHasFreeShipping();
    const amountToFreeShipping = handlers.getAmountToFreeShipping();

    return (
        <div className={styles.notice}>
            {hasFreeShipping ? (
                <Typography as="span" weight="medium" variant="paragraph-S">
                    {translate('basket.basket.freeShipping.summary')}
                </Typography>
            ) : (
                <>
                    <Typography as="span" weight="medium" variant="paragraph-S">
                        {amountToFreeShipping &&
                            translate('basket.basket.forFreeShipping', {
                                amount: String(handlers.getAmountToFreeShipping()),
                            })}
                    </Typography>
                    <button
                        className={styles.continueButton}
                        title={translate('basket.basket.goToCheckout')}
                        aria-label={translate('basket.backButton')}
                        onClick={goBack}
                    >
                        <Typography as="span" weight="medium" variant="paragraph-S">
                            {translate('basket.continueShopping')}
                        </Typography>
                    </button>
                </>
            )}
        </div>
    );
};
